<div class="main-grid"
     id="main-grid-template"
     [ngClass]="{
        'main-grid-easy': this.difficulty === 'EASY',
        'main-grid-medium': this.difficulty === 'MED',
        'main-grid-hard': this.difficulty === 'HARD',
        'main-grid-high-contrast': visualAccessibilityOn,
        'text-color-blind': colorblindModeOn
      }">


  <!-- TROPHY AND STARS AREA -->
  <div class="grid-target" id='trophy-and-stars'>
    <img id="trophy-image" [attr.aria-label]="'palkinnot' | ariaTranslate: uiLanguage" src='./assets/images/UI/Trophy_graphic_1.svg'>
  </div>

  <!-- TITLE AREA -->
  <div class="grid-target description" [ngClass]="{'description-high-contrast':visualAccessibilityOn}">

    <p class="game-over-text" [ngClass]="{'game-over-text-high-contrast':visualAccessibilityOn}">{{'game_over'|translate}}</p>

    <!-- <img *ngIf="!visualAccessibilityOn" id="flame-image" src='./assets/images/UI/Flame_Large_1.svg'> -->

    <div [attr.aria-label]="'tahdet' | ariaTranslate: uiLanguage" id="stars-row">

      <img
           *ngFor="let i of [1, 2, 3, 4, 5]"
           class="star"
           src='{{ (i <= skillLevel) ? "./assets/images/UI/Star_Full_1.svg" : "./assets/images/UI/Star_Empty_1.svg"}}'>
    </div>

    <div >
      <p [ngStyle]="{'margin-bottom':'2px'}">{{'skill_level_intro'|translate}}</p>
      <p
        class="skill-level-title"
        [ngClass]="{
          'skill-level-title-high-contrast':visualAccessibilityOn,
          'skill-level-title-color-blind': colorblindModeOn
        }"
      >
        <b>{{(skillLevelText + skillLevel) | translate}}</b>
      </p>
      <p [ngClass]="{'skill-level-description-high-contrast':visualAccessibilityOn}" [ngStyle]="{'margin-bottom':'2px'}">{{(skillLevelDescription + skillLevel) | translate}}</p>
    </div>

    <div id="statistics">
      <div class='statistics-row'><p>{{'points'|translate}}</p><p>{{endScore}}</p></div>
      <div class='statistics-row'><p>{{'right_answers'|translate}}</p><p>{{correctAnswers}}</p></div>
      <div class='statistics-row'><p>Streak</p><p>x {{highestStreak}}</p></div>
    </div>



  </div>

  <!-- BUTTONS -->
  <div class="grid-target" id='button-area'>
    <div>
      <button mat-button class="button" [ngClass]="{'button-high-contrast':visualAccessibilityOn}" (click)='InitReplay()'>
        <img [attr.aria-label]="'replay_nappula' | ariaTranslate: uiLanguage" src='./assets/images/UI/Replay_1.svg'>
      </button>
      <p
        *ngIf="keyboardControlOn">
        {{(keyboardControlOn ? '[SPACE] ' : '')}}
      </p>
    </div>
    <div [ngStyle]="{'display':'flex', 'flex-direction':'column', 'align-items':'center'}">
      <button mat-button class="button" [ngClass]="{'button-high-contrast':visualAccessibilityOn}" routerLink="/">
        <img [attr.aria-label]="'alkuun_nappula' | ariaTranslate: uiLanguage" src='./assets/images/UI/Home_1.svg'>
      </button>
      <p
        *ngIf="keyboardControlOn">
        {{(keyboardControlOn ? '[ENTER] ' : '')}}
      </p>
    </div>

  </div>

</div>
